// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarOutlinedSvg from "@ant-design/icons-svg/es/asn/CarOutlined";
import AntdIcon from '../components/AntdIcon';

var CarOutlined = function CarOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarOutlinedSvg
  }));
};

CarOutlined.displayName = 'CarOutlined';
export default React.forwardRef(CarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CarOutlined.js
// module id = 721
// module chunks = 0